import {createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {Meta} from './commonTypes'

export enum operSystemEnum {
  // 0 安卓
  android = 0,
  // 1 ios
  ios = 1,
}

export enum hLanguageEnum {
  //  英语
  en = 'en',
  // 阿语
  ar = 'ar',
  // 印尼
  id = 'id',
  //  泰语
  th = 'th',
  //  越南语
  vi = 'vi',
  // 土耳其语
  tr = 'tr',
  // 马来语
  ms = 'ms',
  //  繁体中文
  hk = 'hk',
  //  简体中文
  zh = 'zh',
  // 印地语
  hi = 'hi',
  // 泰米尔语
  ta = 'ta',
  // 泰卢固语
  te = 'te',
  // 旁遮普语
  pa = 'pa',
  // 测试最长语言
  test = 'test',
  // 葡萄牙语
  pt = 'pt',
  // 西班牙语
  es = 'es',
}
// hiya地区、语言对应编码 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17577933
export enum hAreaCodeEnum {
  // 中东区
  ar = 0,
  // 印尼区
  id = 1,
  // 越南区
  vi = 2,
  // 菲律宾
  tp = 3,
  // 新马区(马来西亚+新加坡)
  ms = 4,
  // 泰国
  th = 5,
  //  印度区
  hi = 6,
  // 巴基斯坦区
  pk = 7,
  // 土耳其区
  tr = 8,
  // 海外华语区
  hk = 9,
  // 巴西区
  br = 10,
}
// 地区和语言对应关系
const hAreaCodeLanguageMap = {
  [hAreaCodeEnum.ar]: hLanguageEnum.ar,
  [hAreaCodeEnum.id]: hLanguageEnum.id,
  [hAreaCodeEnum.vi]: hLanguageEnum.vi,
  // [hAreaCodeEnum.tp]:,
  [hAreaCodeEnum.ms]: hLanguageEnum.ms,
  [hAreaCodeEnum.th]: hLanguageEnum.th,
  [hAreaCodeEnum.hi]: hLanguageEnum.hi,
}
export enum hAppEnum {
  lite = 'me-live-lite',
  pro = 'me-live-pro',
  game = 'me-live-game',
  saada = 'saada',
}
export class DeviceinfoSt {
  // 0 安卓 1  ios
  h_dt: 0 | 1

  h_zone_offset: number

  // 区域
  h_area_code: hAreaCodeEnum

  h_test: boolean

  h_av: string

  h_model: string

  h_m: number

  h_ip: string

  h_gender: number

  h_loc: {
    h_lon: number
    h_lat: number
  }

  h_app: hAppEnum

  h_ch: string

  h_sys: string

  h_region_code: number

  h_ts: number

  h_appsflyerid: string

  h_nt: number

  token: string

  h_zone_abbreviation: string

  // 语言
  h_language: hLanguageEnum

  h_web_top: number // 系统顶部状态栏的高度

  // h_web_founction_top字段,专门用于功能面板上按钮点击webview顶部的高度
  h_web_founction_top: number

  h_os: string

  h_adjust: string

  h_zone_name: string

  h_age: number

  h_did: string

  // 房间id
  h_web_room_id: number

  // 4.35.0 新增参数
  h_score: number // 对应的PassMark评分

  h_model_level: number //  0：无对应设备 ； 1：低端性能机 ；2：中端性能机；3：高端性能机
}

export interface envState {
  deviceinfo: DeviceinfoSt
  userAgent: string
  clientIp: string
  host: string
  path: string
  queries: any
  otherInfo: any
  baseHref: string
  meta: Meta
  originalUrl?: string
}
const initialState: envState = {
  deviceinfo: {} as DeviceinfoSt,
  userAgent: '',
  clientIp: '',
  host: '',
  path: '',
  queries: {},
  otherInfo: {},
  baseHref: '',
  meta: {}, // 存放meta数据
}

// export const getenvData = createAction('env/set', async () => {
//   const resp = await new Promise<{title: string}>((res) => {
//     setTimeout(() => {
//       res({title: 'new env title'})
//     }, 50)
//   })
//   return resp.title
// })

export const envSlice = createSlice({
  name: 'env',
  initialState,
  reducers: {
    set: (state, action) => {
      Object.assign(state, action.payload)
    },
    // 限制只能为 本地语 其他语言均为英语
    limitLcocaLanguage: (state) => {
      const {deviceinfo} = state
      const hAreaCodeLanguage = hAreaCodeLanguageMap[deviceinfo.h_area_code]
      if (hAreaCodeLanguage !== deviceinfo.h_language) {
        Object.assign(state, {
          deviceinfo: {
            ...deviceinfo,
            h_language: hLanguageEnum.en,
          },
        })
      }
    },
  },
})

export const useEnv = () => useSelector((store) => store.env)

export const EnvActions = envSlice.actions
export default envSlice.reducer
